import React from "react";

import { css, keyframes, useTheme } from "@emotion/react";
import styled from "@emotion/styled";

import { IconPredefined } from "../icons/Icon";
import useStore from "./store";

const NotificationWrapper = styled.div`
    position: relative;
    z-index: 100;
    opacity: 1;
`;

const fadeIn = keyframes`
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
`;

const fadeOut = keyframes`
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
    }
`;

export const UncontrolledNotification = ({
    type = "default",
    children,
    onClose,
    position = "absolute",
    ...props
}) => {
    const theme = useTheme();
    const colors = {
        success: theme.colors.green.lighten(1.3).toString(),
        error: theme.colors.red.lighten(1.1).toString(),
        default: theme.colors.grey.toString(),
    };
    const NotificationContainer = styled.div`
        position: ${position};
        right: 0;
        left: 0;
        padding: 20px;
        color: ${({ theme }) => theme.colors.blue.toString()};
        border-radius: 4px;
    `;
    const color = colors[type] ?? colors.default;

    const containerStyles = css`
        background-color: ${color};
    `;

    const iconStyles = css`
        position: absolute;
        right: 0;
        cursor: pointer;

        & > svg {
            width: 12px;
            height: 12px;
        }
    `;

    return (
        <NotificationWrapper {...props}>
            <NotificationContainer css={containerStyles}>
                {onClose && (
                    <IconPredefined
                        css={iconStyles}
                        type="close"
                        color={theme.colors.blue.toString()}
                        onClick={onClose}
                    />
                )}
                {children}
            </NotificationContainer>
        </NotificationWrapper>
    );
};

const Notification = () => {
    const {
        notification,
        notificationVisible,
        notificationClosing,
        closeNotification,
    } = useStore();
    const notificationOpeningStyles = css`
        opacity: 0;
        animation: ease 0.25s ${fadeIn} forwards;
    `;

    const notificationClosingStyles = css`
        opacity: 1;
        animation: ease 0.5s ${fadeOut} forwards;
    `;

    return (
        notificationVisible && (
            <UncontrolledNotification
                type="success"
                onClose={closeNotification}
                css={
                    notificationClosing
                        ? notificationClosingStyles
                        : notificationOpeningStyles
                }
            >
                <p>{notification}</p>
            </UncontrolledNotification>
        )
    );
};

export default Notification;
